import { Button } from '../../shadcnComponents/ui/button';
import {
    Breadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbPage,
    BreadcrumbLastItem
} from '../../shadcnComponents/ui/breadcrump';

export function LocationBar(props) {
    // const navigate = useNavigate();

    function handleClick(element) {
        const index = props.folderChain.indexOf(element);
        props.goToDirectory(props.folderChain.slice(0, index + 1));
    }

    return (
        <div className="flex flex-row w-full items-center justify-start mt-8">
            <Breadcrumb>
                <BreadcrumbList>
                    {props.folderChain.map(each => {
                        if (props.folderChain.indexOf(each) < props.folderChain.length - 1) {
                            return (
                                <BreadcrumbItem key={'location' + props.folderChain.indexOf(each)}>
                                    <Button variant="text" className='text-md' id={'location' + props.folderChain.indexOf(each)} onClick={() => { handleClick(each) }} >{each.name ? each.name : ''}</Button>
                                </BreadcrumbItem>
                            )
                        } else {
                            return (
                                <BreadcrumbLastItem key={'location' + props.folderChain.indexOf(each)}>
                                    <BreadcrumbPage key={each.id}>{each.name ? each.name : ''}</BreadcrumbPage>
                                </BreadcrumbLastItem>
                            )
                        }
                    })}
                </BreadcrumbList>
            </Breadcrumb>
        </div>
    )
}
export default LocationBar